import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import useSession from "../../hooks/useSession";
import { RoutePath } from "../../utility/Constant";
import Loading from "../shared/loading/Loading";

function RequireAuth({ children }) {
  const [user, loading] = useSession();
  const location = useLocation();
  const { login } = RoutePath;

  if (loading) {
    return <Loading />;
  }

  if (!user?.name) {
    return <Navigate to={login} state={{ from: location }} replace />;
  }

  return children;
}

export default RequireAuth;
